import { HttpClient } from './serviceBase';
import { utils } from '../utils/utils';

class BranchService {
    GetPrinters = async (branchCode) =>
        await HttpClient.Get(`/api/branches/${branchCode}/printers`);

    GetBranchById = async (branchId) =>
        await HttpClient.Get(`/api/branches/${branchId}`);

    Search = async ( filters ) => {
        const queryString = utils.GetQueryStringsFromObject( filters )
        return await HttpClient.Get(`/api/branches/search?${queryString}`);
    }
}

export default new BranchService();